/** Helmets and masks. The location a critical hit is worth the most against. */

import type { EquipmentSlot } from '@/sim/inventory/slotContract';

export const HEAD_SLOT = {
  id: 'head',
  label: 'Head',
  description: 'Helmets and masks. The location a critical hit is worth the most against.',
} as const satisfies EquipmentSlot;
